import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/_topicDetail.module.scss";
import FadeInSection from "../common/FadeInSection";
import Breadcrumb from "../common/breadcrum";
import { useParams } from "react-router-dom";
import { getTopicById } from "../../api/topic";
import dayjs from "dayjs";
import { LoadingSpin } from "../LoadingSpin";

const TopicDetailComponent = () => {
  const { id } = useParams();
  const [topicDetail, setTopicDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchTopicDetail = async (topicId) => {
      if (!topicId) {
        return;
      }
      setIsLoading(true);
      try {
        const topicDetailData = await getTopicById(topicId);
        setTopicDetail(topicDetailData);
      } catch (error) {
        alert("トピックの詳細の取得に失敗しました");
      } finally {
        setIsLoading(false);
      }
    };
    fetchTopicDetail(id);
  }, [id]);

  return (
    <div className={styles.topicDetail}>
      {topicDetail && !isLoading && (
        <>
          <div className={styles.top}>
            <FadeInSection>
              <div className={styles.title}>
                {topicDetail.title}
              </div>
              <div className={styles.date}>{dayjs(topicDetail.publishedAt).format("YYYY.MM.DD")}</div>
              <div className={styles.thumbnail}>
                <img src={topicDetail.thumbnail.url} alt="Thumbnail" />
              </div>
            </FadeInSection>
          </div>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: topicDetail.content }} />
          {/* <div className={styles.content}>
            <FadeInSection>
              <p>
                「YOLU（ヨル）」は、大西流星さんを起用したWEB
                CM『YOLUの秘密』篇と、撮影の裏側やインタビューを映像化したメイキングムービーを2024年11月21日（木）より公式サイトにて公開します。また、WEB
                CM公開を記念して、対象のヘアケア商品購入で807名に抽選でYOLUオリジナルグッズをプレゼントする『YOLUの秘密キャンペーン』を実施します。
              </p>
              <div className={styles.title}>概要</div>
              <div className={styles.captions}>
                <p>■ WEB CM：『YOLUの秘密』篇（15秒/30秒）</p>
                <p>■ 公開日：11月21日（木）</p>
                <p>■ CMストーリー</p>
              </div>
            </FadeInSection>
            <FadeInSection>
              <p>
                お風呂上がりに濡れた髪をタオルで拭きながら、純白のパジャマ姿で登場する大西さん。「ツヤ髪の秘密は…YOLUを使って眠るだけ」とそっと教えてくれます。ベッドで眠るシーンでは、可愛らしい寝顔に加えて、寝返りを何度も繰り返したり、両手をバンザイしたりと大胆な寝相をのぞき見することができます。翌朝スッキリと目覚めて、着替えを済ませた大西さん。鏡を見ながらサッと整える髪はきれいなツヤ髪で「よし、いい感じ」と出かけていきます。
              </p>
              <p className={styles.videoTitle}>『YOLUの秘密』篇（30秒）</p>
              <div className={styles.video}>
                <img src={img} alt="" />
                <div className={styles.play}>
                  <img src={ytb} alt="" />
                </div>
              </div>
            </FadeInSection>
            <FadeInSection>
              <p className={styles.videoTitle}>『YOLUの秘密』篇（15秒）</p>
              <div className={styles.video}>
                <img src={img} alt="" />
                <div className={styles.play}>
                  <img src={ytb} alt="" />
                </div>
              </div>
            </FadeInSection>
            <FadeInSection>
              <p className={styles.videoTitle}>
                『YOLUの秘密』篇　メイキングムービー
              </p>
              <div className={styles.video}>
                <img src={img} alt="" />
                <div className={styles.play}>
                  <img src={ytb} alt="" />
                </div>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.title}>『YOLUの秘密キャンペーン』概要</div>
              <p>
                対象のヘアケア商品の購入で抽選で807名様にオリジナルグッズをプレゼントする『YOLUの秘密キャンペーン』を実施します。
              </p>
              <div className={styles.detail}>*詳細は特設サイトをご覧ください。</div>
              <div className={styles.nextDetail}>
                <a href="">特設サイトはこちら</a>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.topItem}>
                <p>【応募期間】</p>
                <p>2024年11月21日（木）～ 12月31日（火）23:59</p>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.item}>
                <p>【プレゼント】</p>
                <p>
                  ・A賞　オリジナルナイトキャップ＋ブースターヘアミスト：107名様
                </p>
                <p className={styles.space}>
                  ・B賞　オリジナルポーチ＋バスタブレット（カームナイト）単包：300名様
                </p>
                <p>・C賞　絶景夜空のカード入り　カード用ホルダー：400名様</p>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.item}>
                <p>【対象商品】</p>
                <p>
                  詰め替えパウチ、数量限定商品、季節限定商品を含むヘアケア商品が対象となります。
                </p>
                <span>
                  * バスタブレット、ボディケア商品、お試しサシェは対象外です。
                </span>
                <br />
                <span>* 詳細は特設サイト内「対象商品リスト」をご覧ください。</span>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.item}>
                <p>【対象ショップ】</p>
                <p>
                  全国のドラッグストア、バラエティショップ、ホームセンター、総合スーパー、家電量販店
                </p>
                <span>* 一部取り扱いのない店舗があります。</span>
                <br />
                <span>
                  *
                  オンラインショップ（公式オンラインストア、楽天市場、Amazon、Yahoo！ショッピング、Qoo10、ZOZOTOWN、auPAYマーケット）での購入は対象外です。
                </span>
              </div>
            </FadeInSection>
            <FadeInSection>
              <div className={styles.item}>
                <p>【注意事項】</p>
                <p>・対象商品1点購入で1口応募となります。</p>
                <p>
                  ・一度ご応募したレシート画像で再度ご応募することはできません。
                </p>
                <p>
                  ・有効期間内にご購入いただいたレシートのみ応募可能です。〈2024年11月21日（木）～12月31日（火）23:59〉
                </p>
                <p>
                  ・賞品画像はイメージです。実際の賞品とはデザイン・仕様が一部異なる場合があります。予めご了承ください。
                </p>
              </div>
            </FadeInSection>
          </div> */}
        </>
      )}
      {isLoading && (
        <div className={styles.content}>
          <LoadingSpin />
        </div>
      )}
      {!topicDetail && !isLoading && (
        <div className={styles.content}>
          <p>トピックが見つかりませんでした</p>
        </div>
      )}
      <div className={styles.content}>
        <FadeInSection>
          <div className={styles.previos}>
            <a href="/topics">TOPICS LIST</a>
          </div>
        </FadeInSection>
      </div>
      <Breadcrumb
        data={[
          { title: "TOP", link: "/" },
          { title: "TOPICS", link: "/topics" },
          { title: topicDetail?.title, link: `/topicDetail/${topicDetail?.id}` },
        ]}
      />
    </div >
  );
};

export default TopicDetailComponent;
